<template>
  <Grid
    gtc="1fr 1fr"
    gta="'total-info department-info' 'table table'"
    gap="var(--r-space-md) var(--r-space-sp)"
    class="full-height"
  >
    <DepartmentInfo class="sticky-card" />
    <TotalInfo class="sticky-card" />
    <RecommendationsTable :key="rerenderTable" @rerender-table="rerenderTable++" />
  </Grid>
</template>

<script>
import RecommendationsModule from './recommendations-module'
// Libraries
import { mapActions } from 'vuex'
// Components
import DepartmentInfo from './components/DepartmentInfo'
import TotalInfo from './components/TotalInfo'
import RecommendationsTable from './components/recommendations-table/RecommendationsTable'

export default {
  components: {
    DepartmentInfo,
    TotalInfo,
    RecommendationsTable
  },

  data: () => ({
    rerenderTable: 1
  }),

  beforeCreate() {
    this.$store.registerModule('recommendations', RecommendationsModule)
  },

  beforeDestroy() {
    this.$store.unregisterModule('recommendations')
  },

  created() {
    this.getAndSetStatuses()
  },

  methods: {
    ...mapActions('recommendations', ['getAndSetStatuses'])
  }
}
</script>

<style lang="scss" scoped>
.sticky-card {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
